export default __webpack_public_path__ + "images/hand-holding-phone.09af4d70e1c2007aa476f4e180cf2108.png";